/**
 * A tag a touchpoint can be rolled up or filtered by. Each value is the
 * customer_events column the scope reads, unless the engine computes it.
 */
export enum AttributionScope {
  CHANNEL = "channel",
  CAMPAIGN = "campaign_id",
  RECIPIENT = "recipient_id",
  AUTOMATION = "automation_id",
  AUTOMATION_STEP = "automation_step_id",
  /** A campaign's A/B template variant. */
  VARIANT = "template",
  SHOPPER_AGENT_CONVERSATION = "shopper_agent_conversation_topic_id",
  SHOPPER_AGENT_OUTREACH = "shopper_agent_outreach_topic_id",
  SHOPPER_SUPPORT_TOPIC = "shopper_support_topic_id",
  SUPPORT_MESSAGE = "support_message_id",
  SHOPPER_AGENT_HUMAN_QUEUE_REVIEW = "shopper_agent_human_queue_review",
  /** A Recover conversation. */
  MARKETING_CONVERSATION = "marketing_conversation_id",
  /** Computed; its values are {@link AttributionAuthor}. */
  AUTHOR = "author",
}

/** Who wrote a touchpoint: the values of {@link AttributionScope.AUTHOR}. */
export enum AttributionAuthor {
  /** Campaigns and automations. */
  MARKETING = "marketing",
  /** Live agents texting customers who abandoned their cart. */
  RECOVER = "recover",
  COMMERCE_AGENT = "commerce_agent",
}
